module.exports = {"version":"6.1.5"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 217
// module chunks = 1